import Rubix from './Rubix';

export default Rubix;
